import EditIcon from "@mui/icons-material/Edit";
import { Button } from "react-admin";

const EditBtn = ({ editHandler, ...props }) => {
  return (
    <Button
      startIcon={<EditIcon />}
      label="ra.action.edit"
      sx={{ width: "fit-content" }}
      onClick={editHandler}
      {...props}
    />
  );
};
export default EditBtn;
